import enEmblem from '../assets/odds/en/emblem.webp'
import enGoal01 from '../assets/odds/en/01.webp'
import enGoal02 from '../assets/odds/en/02.webp'
import enGoal03 from '../assets/odds/en/03.webp'
import enGoal04 from '../assets/odds/en/04.webp'
import enGoal05 from '../assets/odds/en/05.webp'
import enGoal06 from '../assets/odds/en/06.webp'
import enGoal07 from '../assets/odds/en/07.webp'
import enGoal08 from '../assets/odds/en/08.webp'
import enGoal09 from '../assets/odds/en/09.webp'
import enGoal10 from '../assets/odds/en/10.webp'
import enGoal11 from '../assets/odds/en/11.webp'
import enGoal12 from '../assets/odds/en/12.webp'
import enGoal13 from '../assets/odds/en/13.webp'
import enGoal14 from '../assets/odds/en/14.webp'
import enGoal15 from '../assets/odds/en/15.webp'
import enGoal16 from '../assets/odds/en/16.webp'
import enGoal17 from '../assets/odds/en/17.webp'
import frEmblem from '../assets/odds/fr/emblem.webp'
import frGoal01 from '../assets/odds/fr/01.webp'
import frGoal02 from '../assets/odds/fr/02.webp'
import frGoal03 from '../assets/odds/fr/03.webp'
import frGoal04 from '../assets/odds/fr/04.webp'
import frGoal05 from '../assets/odds/fr/05.webp'
import frGoal06 from '../assets/odds/fr/06.webp'
import frGoal07 from '../assets/odds/fr/07.webp'
import frGoal08 from '../assets/odds/fr/08.webp'
import frGoal09 from '../assets/odds/fr/09.webp'
import frGoal10 from '../assets/odds/fr/10.webp'
import frGoal11 from '../assets/odds/fr/11.webp'
import frGoal12 from '../assets/odds/fr/12.webp'
import frGoal13 from '../assets/odds/fr/13.webp'
import frGoal14 from '../assets/odds/fr/14.webp'
import frGoal15 from '../assets/odds/fr/15.webp'
import frGoal16 from '../assets/odds/fr/16.webp'
import frGoal17 from '../assets/odds/fr/17.webp'
import deEmblem from '../assets/odds/de/emblem.webp'
import deGoal01 from '../assets/odds/de/01.webp'
import deGoal02 from '../assets/odds/de/02.webp'
import deGoal03 from '../assets/odds/de/03.webp'
import deGoal04 from '../assets/odds/de/04.webp'
import deGoal05 from '../assets/odds/de/05.webp'
import deGoal06 from '../assets/odds/de/06.webp'
import deGoal07 from '../assets/odds/de/07.webp'
import deGoal08 from '../assets/odds/de/08.webp'
import deGoal09 from '../assets/odds/de/09.webp'
import deGoal10 from '../assets/odds/de/10.webp'
import deGoal11 from '../assets/odds/de/11.webp'
import deGoal12 from '../assets/odds/de/12.webp'
import deGoal13 from '../assets/odds/de/13.webp'
import deGoal14 from '../assets/odds/de/14.webp'
import deGoal15 from '../assets/odds/de/15.webp'
import deGoal16 from '../assets/odds/de/16.webp'
import deGoal17 from '../assets/odds/de/17.webp'
import ptbrEmblem from '../assets/odds/pt-br/emblem.webp'
import ptbrGoal01 from '../assets/odds/pt-br/01.webp'
import ptbrGoal02 from '../assets/odds/pt-br/02.webp'
import ptbrGoal03 from '../assets/odds/pt-br/03.webp'
import ptbrGoal04 from '../assets/odds/pt-br/04.webp'
import ptbrGoal05 from '../assets/odds/pt-br/05.webp'
import ptbrGoal06 from '../assets/odds/pt-br/06.webp'
import ptbrGoal07 from '../assets/odds/pt-br/07.webp'
import ptbrGoal08 from '../assets/odds/pt-br/08.webp'
import ptbrGoal09 from '../assets/odds/pt-br/09.webp'
import ptbrGoal10 from '../assets/odds/pt-br/10.webp'
import ptbrGoal11 from '../assets/odds/pt-br/11.webp'
import ptbrGoal12 from '../assets/odds/pt-br/12.webp'
import ptbrGoal13 from '../assets/odds/pt-br/13.webp'
import ptbrGoal14 from '../assets/odds/pt-br/14.webp'
import ptbrGoal15 from '../assets/odds/pt-br/15.webp'
import ptbrGoal16 from '../assets/odds/pt-br/16.webp'
import ptbrGoal17 from '../assets/odds/pt-br/17.webp'
import esEmblem from '../assets/odds/es/emblem.webp'
import esGoal01 from '../assets/odds/es/01.webp'
import esGoal02 from '../assets/odds/es/02.webp'
import esGoal03 from '../assets/odds/es/03.webp'
import esGoal04 from '../assets/odds/es/04.webp'
import esGoal05 from '../assets/odds/es/05.webp'
import esGoal06 from '../assets/odds/es/06.webp'
import esGoal07 from '../assets/odds/es/07.webp'
import esGoal08 from '../assets/odds/es/08.webp'
import esGoal09 from '../assets/odds/es/09.webp'
import esGoal10 from '../assets/odds/es/10.webp'
import esGoal11 from '../assets/odds/es/11.webp'
import esGoal12 from '../assets/odds/es/12.webp'
import esGoal13 from '../assets/odds/es/13.webp'
import esGoal14 from '../assets/odds/es/14.webp'
import esGoal15 from '../assets/odds/es/15.webp'
import esGoal16 from '../assets/odds/es/16.webp'
import esGoal17 from '../assets/odds/es/17.webp'

const EN = {
  poverty: enGoal01,
  hunger: enGoal02,
  health: enGoal03,
  education: enGoal04,
  gender_equality: enGoal05,
  water: enGoal06,
  energy: enGoal07,
  economic_growth: enGoal08,
  infrastructure: enGoal09,
  inequality: enGoal10,
  cities: enGoal11,
  consumption: enGoal12,
  climate: enGoal13,
  marine: enGoal14,
  land: enGoal15,
  peace: enGoal16,
  partnerships: enGoal17,
  emblem: enEmblem,
}

export default {
  en: EN,
  fr: {
    poverty: frGoal01,
    hunger: frGoal02,
    health: frGoal03,
    education: frGoal04,
    gender_equality: frGoal05,
    water: frGoal06,
    energy: frGoal07,
    economic_growth: frGoal08,
    infrastructure: frGoal09,
    inequality: frGoal10,
    cities: frGoal11,
    consumption: frGoal12,
    climate: frGoal13,
    marine: frGoal14,
    land: frGoal15,
    peace: frGoal16,
    partnerships: frGoal17,
    emblem: frEmblem,
  },
  'pt-br': {
    poverty: ptbrGoal01,
    hunger: ptbrGoal02,
    health: ptbrGoal03,
    education: ptbrGoal04,
    gender_equality: ptbrGoal05,
    water: ptbrGoal06,
    energy: ptbrGoal07,
    economic_growth: ptbrGoal08,
    infrastructure: ptbrGoal09,
    inequality: ptbrGoal10,
    cities: ptbrGoal11,
    consumption: ptbrGoal12,
    climate: ptbrGoal13,
    marine: ptbrGoal14,
    land: ptbrGoal15,
    peace: ptbrGoal16,
    partnerships: ptbrGoal17,
    emblem: ptbrEmblem,
  },
  es: {
    poverty: esGoal01,
    hunger: esGoal02,
    health: esGoal03,
    education: esGoal04,
    gender_equality: esGoal05,
    water: esGoal06,
    energy: esGoal07,
    economic_growth: esGoal08,
    infrastructure: esGoal09,
    inequality: esGoal10,
    cities: esGoal11,
    consumption: esGoal12,
    climate: esGoal13,
    marine: esGoal14,
    land: esGoal15,
    peace: esGoal16,
    partnerships: esGoal17,
    emblem: esEmblem,
  },
  de: {
    poverty: deGoal01,
    hunger: deGoal02,
    health: deGoal03,
    education: deGoal04,
    gender_equality: deGoal05,
    water: deGoal06,
    energy: deGoal07,
    economic_growth: deGoal08,
    infrastructure: deGoal09,
    inequality: deGoal10,
    cities: deGoal11,
    consumption: deGoal12,
    climate: deGoal13,
    marine: deGoal14,
    land: deGoal15,
    peace: deGoal16,
    partnerships: deGoal17,
    emblem: deEmblem,
  },
} as const
